import { defineStore } from 'pinia';
import type { ITeaser } from '~~/types/local_types'; // Adjust this path to your actual types

type TStoreState = {
  short?: undefined | ITeaser;
};

const useShortStore = defineStore('short', {
  state: (): TStoreState => ({
    short: undefined,
  }),

  actions: {
    setShort(data?: ITeaser) {
      this.short = data;
    },
    clearShort() {
      this.short = undefined;
    },
  },

  getters: {
    currentShort: (state) => state.short,
    hasShort: (state): boolean => !!state.short,
  },
});

export default useShortStore;
